import { defineMessages } from 'react-intl'

export default defineMessages({
  extension: {
    id: 'components.UsageStatusChip.extension',
    defaultMessage: 'Ext.',
  },
  startsIn: {
    id: 'components.UsageStatusChip.startsIn',
    defaultMessage: 'Starts In ',
  },
  days: {
    id: 'components.UsageStatusChip.days',
    defaultMessage: 'd',
  },
  daysLeft: {
    id: 'components.UsageStatusChip.daysLeft',
    defaultMessage: 'd left',
  },
  expired: {
    id: 'components.UsageStatusChip.expired',
    defaultMessage: 'Expired',
  },
  inPerpetuity: {
    id: 'components.UsageStatusChip.inPerpetuity',
    defaultMessage: 'In Perpetuity',
  },
  reminderDisabled: {
    id: 'components.UsageStatusChip.reminderDisabled',
    defaultMessage: 'Notification off',
  },
})
